import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useSnapchatBusinessManagerStore = defineStore({
  id: 'snapchatBusinessManagerStore',
  state: () => ({
    snapchatBusinessManagers: [],
    snapchatBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getSnapchatBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.snapchatBusinessManagersLoading = true

      try {
        const {data} = await axios.get('snapchat/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.snapchatBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.snapchatBusinessManagersLoading = false
      }
    },

    async createSnapchatBusinessManager(payload) {
      this.error = null
      this.snapchatBusinessManagersLoading = true

      try {
        const {data} = await axios.post('snapchat/business-managers', payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.snapchatBusinessManagersLoading = false
      }
    },

    async updateSnapchatBusinessManager(id, payload) {
      this.error = null
      this.snapchatBusinessManagersLoading = true

      try {
        let {data} = await axios.patch(`snapchat/business-managers/${id}`, payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.snapchatBusinessManagersLoading = false
      }
    },

    async updateSnapchatBusinessManagerProviders(hash, payload) {
      const {data} = await axios.patch(`snapchat/business-managers/${hash}/providers`, payload)

      return data
    },

    async getSnapchatProviders(filters = {}) {
      this.error = null
      this.loading = true

      try {
        const {data} = await axios.get('snapchat/providers', {params: filters})
        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.loading = false
      }
    },
  },
})
